import * as R from 'remeda';
import {
  SchemaDatapointString,
  SchemaSection,
} from '@rossum/api-client/schemas';
import { isNotNullOrUndefined } from '../../../../../lib/typeGuards';
import { LookupVariables } from './extractDependenciesPerQuery';

export const ARTIFICIAL_VARIABLE_PREFIX = '__var__';

export const makeArtificialVariablesSchema = (
  variables: LookupVariables
): SchemaSection[] => {
  return [
    {
      id: 'artificial_variables_section',
      label: 'Variables',
      category: 'section',
      hidden: false,
      disablePrediction: false,
      children: R.pipe(
        variables,
        R.entries(),
        R.filter((entry): entry is [string, { __formula: string }] =>
          isNotNullOrUndefined(entry[1].__formula)
        ),
        R.map(
          ([name, v]): SchemaDatapointString => ({
            id: `${ARTIFICIAL_VARIABLE_PREFIX}${name}`,
            label: name,
            category: 'datapoint',
            type: 'string',
            formula: v.__formula,
            uiConfiguration: { type: 'formula', edit: 'disabled' },
          })
        )
      ),
    },
  ];
};
